import paper from 'paper';
import Api from '@/services/Api';
import Log from 'loglevel';
import store from '../store';
import PathUtils from '@/services/PathUtils';
import {Helper} from 'dxf';
import PainterService from './PainterService';

const delay = ms => new Promise(res => setTimeout(res, ms));

export default {
    async importDxfUrl(url) {
        store.dispatch('setMode', 'blueprint');
        store.dispatch('setLoadingStep', 'Récupération du fichier DXF...');

        let response = await fetch(url);
        if (response.ok) {
            store.dispatch('setLoadingStep', 'Import...');
            this.importDxfData(await response.text());
        } else {
            console.error("DXF File not found");
        }
    },

    async importDxf(file) {
        store.dispatch('setMode', 'blueprint');
        store.dispatch('setLoadingStep', 'Conversion du fichier DXF...');
        await delay(1);
        await PathUtils.clearProject();
        this.importDxfData(await file.text());
    },

    async importDxfData(dxfData) {
        let svgData = await new Helper(dxfData).toSVG();
        let importLayer = paper.project.layers.import;

        await PathUtils.importSVG(svgData, importLayer);

        let colors = importLayer.getItems({ class: 'Path' })
            .reduce(function (colors, path) {
                let color = path.strokeColor ? path.strokeColor.toCSS() : '';
                if (colors.indexOf(color) === -1) colors.push(color);
                return colors;
            }, []);
        store.dispatch('setAvailableColors', colors.join(";"));

        let blueprintLayer = paper.project.layers.blueprint;

        PathUtils.selectAll(importLayer);

        await PathUtils.updateBlueprint(importLayer, blueprintLayer, async report => {
            if (report == null || report.quickAnalysis == null || !report.quickAnalysis.pass) {
                PathUtils.ignoreAll(importLayer);
                await PathUtils.updateBlueprint(importLayer, blueprintLayer);
            }
        });
    },

    async loadDxfImport(dxfImport) {
        console.info("Edition du fichier : " + dxfImport.filename);
        store.dispatch('setLoadingStep', 'Chargement du fichier' + dxfImport.filename);
        store.dispatch('setMode', 'blueprint');
        let importLayer = paper.project.layers.import;

        await PathUtils.loadDxfImport(dxfImport, importLayer);

        let colors = importLayer.getItems({ class: 'Path' })
            .reduce(function (colors, path) {
                let color = path.strokeColor ? path.strokeColor.toCSS() : '';
                if (colors.indexOf(color) === -1) colors.push(color);
                return colors;
            }, []);
        store.dispatch('setAvailableColors', colors.join(";"));

        let blueprintLayer = paper.project.layers.blueprint;
        PathUtils.selectAll(importLayer);

        await PathUtils.updateBlueprint(importLayer, blueprintLayer, async report => {
            if (report == null || report.quickAnalysis == null || !report.quickAnalysis.pass) {
                PathUtils.ignoreAll(importLayer);
                await PathUtils.updateBlueprint(importLayer, blueprintLayer);
            }
            PainterService.afterZoom();
        });

        store.dispatch('setLoadingStep', '');
    },

    async exportToDxf (pieceId,compositionId) {
        try {
            const downloadDxfResponse = await Api().get(
                'compositions/' + compositionId,
                {
                    headers: {
                        'Authorization': `Bearer ${window.localStorage.getItem('feathers-jwt')}`,
                        'Accept': 'application/dxf',
                        'Piece-Id': pieceId
                    }
                }
            );

            return downloadDxfResponse.data;
        }
        catch (error) {
            if (error.response) {
                Log.warn("Erreur API : " + error.message);
            } else if (error.request) {
                Log.warn("Pas de réponse de l'API... : " + error.message);
            } else {
                Log.warn("Erreur interne : " + error.message);
            }
            return;
        }
    }
}
